import {BMTheme} from "../../BMTheme";

const layoutStyle = {
  main: {
    display: "flex",
    minHeight: "100vh",
    flexDirection: "row",
    flex: 1,
    overflowY: "hidden",
    overflowX: "auto"
  },

  drawer: {
    height: "100%",
    backgroundColor: BMTheme.drawer.desktop.backgroundColor,
    color: BMTheme.drawer.desktop.color,
    display: "flex",
    flexDirection: "column",
    flex: 1
  },

  userContainer: {
    height: "74px",
    borderBottomStyle: "solid",
    borderBottomWidth: 0.1,
    borderBottomColor: BMTheme.drawer.borderColor,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },

  avatar: {
    flex: 0.3,
    marginLeft: "10%"
  },

  userInfo: {
    flex: 0.7,
    padding: "1%",
    textStyle: {
      fontSize: 12
    }
  },

  sidebar: {
    display: "flex",
    flexDirection: "column",
    flex: 0.8,
    menu: {
      flex: 0.95
    }
  },

  logo: {
    paddingBottom: "0.5em",
    height: "1em",
    justifyContent: "center",
    imageStyle: {
      width: "100%"
    },
    textStyle: {
      textAlign: "center"
    }
  },

  body: {
    backgroundColor: BMTheme.body.desktop.backgroundColor,
    display: "flex",
    flex: 1,
    flexDirection: "column"
  },

  content: {
    flex: 1,
    padding: "2em",
    backgroundColor: BMTheme.body.desktop.content.backgroundColor,
    withoutPermission: {
      textAlign: "center"
    }
  },

  loader: {
    position: "absolute",
    top: 0,
    right: 0,
    margin: 16,
    zIndex: 1200
  }
};

export default layoutStyle;



// WEBPACK FOOTER //
// ./src/components/Layout/style.js